<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 15:31:38
 * @LastEditors: 诺
 * @LastEditTime: 2022-01-18 21:17:23
-->
<template>
  <div class="turntableMain" :style="{ backgroundImage: `url(${config.wheelBackgroundImg})` }">
    <div
      class="turntableBg"
      :style="{
        backgroundImage: `url(${config.wheelBaseImg})`,
        transform: transform,
        transition: transition,
      }"
    >
      <Grid :prizeList="prize"></Grid>
      <!-- :transform="transform"
        :transition="'transform ' + transition + 's ease'" -->
      <!-- <div class="prizeGrid" :prizeList="prizeList"></div> -->
    </div>
    <div class="turntabPointer">
      <img :src="config.wheelPointerImg" />
    </div>
    <div class="gameCount act-text-stroke" v-if="!(config.lotteryTimesLimitSwitch == 0 && config.lotteryTimesDailyLimitSwitch == 0)">还剩 {{ gameCount }} 次</div>
    <div class="turntabbtn">
      <div class="draw" @click="$emit('handleStartGame')"></div>
      <img :src="config.wheelButtonImg" />
    </div>
    <BaseRollWins class="rollWins" :wins="winUser" v-if="config.rotationWinSwitch == 1 && winUser.length > 3"></BaseRollWins>
  </div>
</template>
<script>
import Grid from "./grid";
export default {
  components: { Grid },
  props: {
    config: {
      type: Object,
    },
    colorItem: {
      type: Object,
      default: () => ({
        color1: "#fdf3aa",
        color2: "#f1d5b1",
        color3: "#b57640",
        color4: "#ff302e",
      }),
    },
    prizeList: {
      type: Array,
    },
    transform: {
      type: String,
      default: "",
    },
    transition: {
      type: String,
      default: "",
    },
    gameCount: {
      type: Number,
      default: 0,
    },
    winUser: {
      type: Array,
    },
  },
  watch: {
    prizeList: {
      handler(val) {
        let rotate = 360 / (val.length + 1);
        this.rotate = rotate;
        this.prize = val.concat({
          code: "thanks",
          img: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/icon1.png",
          name: "谢谢参与",
        });
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      rotate: 0, //每个奖品度数
      prize: [],
    };
  },
  created() {
    // let rotate = 360 / this.prizeList.length;
    // this.rotate = rotate;
  },

  // wheelBackgroundImg:
  //   "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryBg.png",
  // wheelBaseImg:
  //   "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryBg2.png?v=20220120",
  // wheelPointerImg:
  //   "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryPointer.png",
  // wheelButtonImg:
  //   "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/draw.png",
  methods: {},
};
</script>
<style lang="stylus" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.turntableMain {
  width: 375px;
  height: 520px;
  overflow-x: hidden;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  margin: 18px auto 0;

  .turntableBg {
    position: absolute;
    width: 291px;
    height: 291px;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    top: 38px;
    left: 42px;
  }

  .turntabPointer {
    position: absolute;
    width: 112px;
    top: 128px;
    left: 132px;
  }

  .gameCount {
    position: absolute;
    width: 96px;
    height: 20px;
    top: 359px ;
    left:140px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  .turntabbtn {
    position: absolute;
    width: 160px;
    top: 389px;
    left: 108px;
    // margin: 10px auto 0;

    .draw {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 999;
    }
  }
  .rollWins {
    position: absolute;
    top: 469px;
    width: 240px;
    left: 67.5px;
    height: 34px;
  }
}
</style>
